import {WindowRef} from '../../providers/window';
import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-tangle',
  templateUrl: './tangle.component.html',
  styleUrls: ['./tangle.component.css']
})
export class TangleComponent implements OnInit {

  constructor(private window: WindowRef) {this.window.nativeWindow.mixpanel.track("Tangle: Page start")}

  ngOnInit() {document.getElementsByTagName('iframe')[0].style.height = window.innerHeight - 50 + 'px'}
}





// WEBPACK FOOTER //
// /home/manu/ArtCode/artCode/artCode/src/app/pages/tangle/tangle.component.ts